module.exports = __webpack_public_path__ + "static/media/login-background.c2a9c9b0.png";